import React from 'react'
export const OldCartContext = React.createContext({})
